// Shared formatting helpers and Miami 21 transect reference (general public code info).

const localeFor = (lang) => (lang === "es" ? "es-US" : "en-US");

export const fmtInt = (n, lang = "en") => {
  if (n === null || n === undefined || n === "") return "—";
  const num = Number(n);
  if (Number.isNaN(num)) return "—";
  return num.toLocaleString(localeFor(lang));
};

export const fmtSqft = (n, lang = "en") => {
  if (n === null || n === undefined || n === "") return "—";
  const num = Number(n);
  if (Number.isNaN(num)) return "—";
  const acres = num / 43560;
  const unit = lang === "es" ? "pies²" : "sq ft";
  return `${num.toLocaleString(localeFor(lang))} ${unit} · ${acres.toFixed(2)} ac`;
};

export const fmtMoney = (n, lang = "en") => {
  if (n === null || n === undefined || n === "") return "—";
  const num = Number(n);
  if (Number.isNaN(num)) return "—";
  return num.toLocaleString(localeFor(lang), { style: "currency", currency: "USD", maximumFractionDigits: 0 });
};

// Format a 13-digit Miami-Dade folio into the standard dashed form: NN-NNNN-NNN-NNNN
export const fmtFolio = (folio) => {
  if (!folio) return "—";
  const d = String(folio).replace(/\D/g, "");
  if (d.length !== 13) return folio;
  return `${d.slice(0, 2)}-${d.slice(2, 6)}-${d.slice(6, 9)}-${d.slice(9)}`;
};

export const fmtDate = (iso, lang = "en") => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString(localeFor(lang), { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return iso;
  }
};

// Transect tone accents (labels/descriptions live in i18n as t.<key>.label / .scale).
const TRANSECT_TONE = {
  T3: "emerald", T4: "teal", T5: "sky", T6: "indigo",
  CS: "green", CI: "amber", D1: "orange", D2: "orange", D3: "sky",
};

export const transectFor = (zone) => {
  if (!zone) return null;
  const key = String(zone).toUpperCase().slice(0, 2);
  if (!TRANSECT_TONE[key]) return null;
  return { key, tone: TRANSECT_TONE[key] };
};
